import { render } from "./ReviewCommentTextArea.vue?vue&type=template&id=377d6510&ts=true"
import script from "./ReviewCommentTextArea.ts?vue&type=script&lang=ts&external"
export * from "./ReviewCommentTextArea.ts?vue&type=script&lang=ts&external"

import "./ReviewCommentTextArea.vue?vue&type=style&index=0&id=377d6510&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__